import React from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const AdditionalDetailsForm = ({
  item,
  setItem,
  inputDisplay,
  setInputDisplay,
  options,
  colors,
  t,
}) => {
  return (
    <div className='space-y-6'>
      {/* CATEGORY */}
      <section>
        <TextField
          fullWidth
          select
          label={t("tables:category")}
          value={item.category || ""}
          onChange={(e) => {
            setItem({ ...item, category: e.target.value });
            setInputDisplay({ ...inputDisplay, category: "bg-white" });
          }}
          variant='outlined'
          size='small'>
          {options.map((option) => (
            <MenuItem
              key={option.id}
              value={option.id}>
              {option.category}
            </MenuItem>
          ))}
        </TextField>
      </section>

      {/* MODEL */}
      <section>
        <TextField
          fullWidth
          label={t("addProductPage:modelLabel")}
          name='model'
          value={item.model}
          onChange={(e) => setItem({ ...item, model: e.target.value })}
          multiline
          variant='outlined'
          size='small'
        />
      </section>

      {/* COLOR */}
      <section>
        <TextField
          fullWidth
          select
          label={t("addProductPage:colorLabel")}
          value={item.color || ""}
          onChange={(e) => {
            setItem({ ...item, color: e.target.value });
            setInputDisplay({ ...inputDisplay, color: "bg-white" });
          }}
          variant='outlined'
          size='small'>
          {colors.map((color) => (
            <MenuItem
              key={color.id}
              value={color.id}>
              {color.color}
            </MenuItem>
          ))}
        </TextField>
      </section>

      {/* DIMENSIONS */}
      <section>
        <h2 className='text-lg font-bold text-gray-700 mb-3'>
          {t("addProductPage:dimensionsLabel")}
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
          <TextField
            fullWidth
            label={t("productPage:height")}
            name='height'
            type='number'
            value={item.dimension?.height || ""}
            onChange={(e) =>
              setItem({
                ...item,
                dimension: {
                  ...item.dimension,
                  height: Number(e.target.value),
                },
              })
            }
            variant='outlined'
            size='small'
          />
          <TextField
            fullWidth
            label={t("productPage:length")}
            name='width'
            type='number'
            value={item.dimension?.width || ""}
            onChange={(e) =>
              setItem({
                ...item,
                dimension: {
                  ...item.dimension,
                  width: Number(e.target.value),
                },
              })
            }
            variant='outlined'
            size='small'
          />
          <TextField
            fullWidth
            label={t("productPage:depth")}
            name='depth'
            type='number'
            value={item.dimension?.depth || ""}
            onChange={(e) =>
              setItem({
                ...item,
                dimension: {
                  ...item.dimension,
                  depth: Number(e.target.value),
                },
              })
            }
            variant='outlined'
            size='small'
          />
        </div>
      </section>

      {/* ROOM CHECKBOXES */}
      <section className='bg-white border border-gray-200 rounded-xl p-6 shadow-sm'>
        <h2 className='text-base font-bold text-gray-700 mb-4'>
          {t("addProductPage:roomLabel")}
        </h2>
        <div className='grid grid-cols-2 md:grid-cols-3 gap-3'>
          {[
            "balcony",
            "bathroom",
            "bedroom",
            "foyer",
            "kitchen",
            "living room",
            "office",
          ].map((roomKey) => (
            <FormControlLabel
              key={roomKey}
              control={
                <Checkbox
                  color='primary'
                  checked={item.rooms?.includes(roomKey)}
                  onChange={(e) => {
                    const updatedRooms = e.target.checked
                      ? [...(item.rooms || []), roomKey]
                      : (item.rooms || []).filter((r) => r !== roomKey);

                    setItem((prev) => ({ ...prev, rooms: updatedRooms }));
                  }}
                />
              }
              label={t(`productTypes:${roomKey.replace(" ", "")}`)}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default AdditionalDetailsForm;
